module.exports = __webpack_public_path__ + "assets/img/tab_img_tzc.7cb5f3d1.png";